"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InstallmentsSelector = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _constants = require("../../../constants");

var _useInstallmentsSelector = require("./useInstallmentsSelector");

var _InstallmentsSelector = require("./InstallmentsSelector.style");

var _core = require("@emotion/core");

const installmentSchema = process.env.NODE_ENV !== "production" ? (0, _propTypes.shape)({
  interestRateMonthly: _propTypes.number,
  installmentsQuantity: _propTypes.number,
  installmentsAmount: _propTypes.number
}) : {};
const propTypes = process.env.NODE_ENV !== "production" ? {
  values: (0, _propTypes.arrayOf)(installmentSchema),
  selectedBy: (0, _propTypes.oneOf)([_constants.OrderBy.MIN, _constants.OrderBy.MAX]),
  selectedInstallment: installmentSchema.isRequired,
  onSelectInstallment: _propTypes.func.isRequired
} : {};

const InstallmentsSelector = ({
  values,
  selectedBy,
  selectedInstallment,
  onSelectInstallment
}) => {
  const {
    installmentsContainerElement,
    installmentInfo,
    monthlyFeeObservations
  } = (0, _useInstallmentsSelector.useInstallmentsSelector)({
    selectedBy,
    selectedInstallment
  });

  const renderInstallmentItem = (installment = {}) => {
    const isSelected = selectedInstallment.installmentsQuantity === installment.installmentsQuantity;
    return (0, _core.jsx)(_InstallmentsSelector.InstallmentsQuantityButton, {
      key: installment.installmentsQuantity,
      onClick: () => onSelectInstallment(installment),
      isSelected: isSelected
    }, String(installment.installmentsQuantity));
  };

  const renderInstallments = () => values.map(renderInstallmentItem);

  return (0, _core.jsx)(_InstallmentsSelector.Container, null, (0, _core.jsx)(_InstallmentsSelector.Container.Information, null, (0, _core.jsx)(_InstallmentsSelector.InstallmentsLabel, {
    desktop: "xs",
    mobile: "xs",
    weight: "lg",
    color: "fontNeutral60"
  }, "PARCELAS A PARTIR DE"), (0, _core.jsx)(_InstallmentsSelector.InstallmentInfo, {
    desktop: "3xl",
    mobile: "2xl",
    weight: "xs"
  }, installmentInfo), (0, _core.jsx)(_InstallmentsSelector.MonthlyFeeObservations, {
    desktop: "sm",
    mobile: "sm",
    weight: "sm",
    color: "fontNeutral60"
  }, monthlyFeeObservations)), (0, _core.jsx)(_InstallmentsSelector.Container.Installments, {
    ref: installmentsContainerElement
  }, renderInstallments()));
};

exports.InstallmentsSelector = InstallmentsSelector;
process.env.NODE_ENV !== "production" ? InstallmentsSelector.propTypes = propTypes : void 0;
InstallmentsSelector.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InstallmentsSelector",
  "props": {
    "values": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "installmentSchema"
        }
      },
      "required": false,
      "description": ""
    },
    "selectedBy": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "OrderBy.MIN",
          "computed": true
        }, {
          "value": "OrderBy.MAX",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "selectedInstallment": {
      "type": {
        "name": "custom",
        "raw": "installmentSchema.isRequired"
      },
      "required": false,
      "description": ""
    },
    "onSelectInstallment": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};